import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Password} from 'primereact/password';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {FileUpload} from "primereact/fileupload";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

import {InputSwitch} from "primereact/inputswitch";

const CompanyFormComponent = (props) => {
  const {t} = props;

  const [formData, setFormData] = useState({
    address_country_code: "HU",
    active: true,
    exchange_rate_provider: "EKB",
  });
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [receiptGroups, setReceiptGroups] = useState([]);
  const [logoUrl, setLogoUrl] = useState(null);

  const validate = (data) => {
    let errors = {};
    if (!data.name?.trim()) errors.name = 'A megnevezés nem lehet üres';
    // if (!data.vat_number) {
    //   errors.vat_number = 'Az adószám nem lehet üres';
    // }
    return errors;
  };

  const onSubmit = (data, form) => {
    setLoading(true)
    const roles_str = (localStorage.getItem('roles') || '').toString();
    const can_update = roles_str.includes('role_company_update');
    const can_create = roles_str.includes('role_company_create');
    const is_update_mode = !!(props && props.initialValues && props.initialValues.id) || !!formData.id;
    if (is_update_mode && !can_update) {
      window.App.toastShow('error', t('toastError'), t('permissionUpdateDenied'));
      setLoading(false);
      return;
    }
    if (!is_update_mode && !can_create) {
      window.App.toastShow('error', t('toastError'), t('permissionCreateDenied'));
      setLoading(false);
      return;
    }
    setFormData({
      ...formData,
      ...data
    });
    const payload = {
        name: data.name,
        exchange_rate_provider: data.exchange_rate_provider || "EKB",
        vat_number: data.vat_number,
        community_vat_number: data.community_vat_number,
        registration_number: data.registration_number,
        email: data.email,
        phone: data.phone,
        active: data.active !== false,
        address_country_code: data.address_country_code,
        address_postal_code: data.address_postal_code,
        address_city: data.address_city,
        address_detail: data.address_detail
    };
    if (props && props.initialValues) {
      apiCall('patch', `/api/v2/company/${formData.id}`, payload)
        .then(response => {
          window.App.toastShow('success', t('toastUpdateSuccess'));
          window.App.setState({
            rerenderCompanyList: true,
            sidebarCompanyUpdate: false
          })
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', t('toastError'), error.toString(), '', error.response);
          setLoading(false)
        })
    } else {
      apiCall('post', `/api/v2/company`, payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({
            rerenderCompanyList: true,
            sidebarCompanyCreate: false
          })
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', t('toastError'), error.toString(), '', error.response);
          setLoading(false)
        })
    }

  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const loadCompany = (companyId) => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/company/" + companyId,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    }).then(r => r.data.data);
  };

  const loadCompanyNav = (companyId) => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/company-nav/" + companyId,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    }).then(r => r.data.data);
  };

  const loadAllCompanyData = (companyId) => {
    return loadCompany(companyId)
      .then(async (company) => {
        if (process.env.REACT_APP_COMPANY_NAV_INTERFACE === 'true') {
          try {
            const nav = await loadCompanyNav(companyId);
            return { ...company, ...nav };
          } catch (e) {
            return company;
          }
        }
        return company;
      })
      .then((merged) => {
        if (merged.nav_invoice_receipt_group && typeof merged.nav_invoice_receipt_group === 'object') {
          merged.nav_invoice_receipt_group = merged.nav_invoice_receipt_group.id;
        }
        setFormData(merged);
        return merged;
      });
  };

  const saveNavSettings = () => {
    setLoading(true);
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API_HOST + "/api/v2/company-nav/" + formData.id,
      data: {
        nav_test: !!formData.nav_test,
        nav_user_name: formData.nav_user_name || null,
        nav_user_pass: formData.nav_user_pass || null,
        nav_x_m_l_sign_key: formData.nav_x_m_l_sign_key || null,
        nav_x_m_l_exchange_key: formData.nav_x_m_l_exchange_key || null,
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(() => {
        window.App.toastShow('success', t('toastSaveSuccess'));
        return loadAllCompanyData(formData.id);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  // image
  const imageUpload = async (files) => {
    const f = files?.files?.[0];
    if (!f) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('file', f);
      const up = await axios.post(
        process.env.REACT_APP_API_HOST + '/api/v2/file/upload',
        fd,
        {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('userToken'),
            'App-Network': localStorage.getItem('networkId'),
          }
        }
      );
      const newFileId = up?.data?.data?.id ?? up?.data?.id;
      if (!newFileId) throw new Error('Nem érkezett file id a feltöltésből.');
      await apiCall('patch', `/api/v2/company/${formData.id}`, {
        // ...formData,
        logo: Number(newFileId)
      });
      window.App.toastShow('success', 'Sikeres logó feltöltés');
      loadAllCompanyData(formData.id);
    } catch (err) {
      window.App.toastShow('error', 'Hiba történt!', err.toString(), '', err.response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/country", {
      headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setCountries(response.data.data || [])
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
    if (props && props.initialValues && props.initialValues.id) {
      loadAllCompanyData(props.initialValues.id)
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        });
    }
  }, [])

  useEffect(() => {
    if (!formData.id || process.env.REACT_APP_COMPANY_NAV_INTERFACE !== 'true') return;
    apiCall('get', `/api/v2/company/${formData.id}/nav-receipt-groups`)
      .then(response => setReceiptGroups(response.data.data.items || []))
      .catch(error => window.App.toastShow('error', t('toastError'), error.toString(), '', error.response));
  }, [formData.id]);

  useEffect(() => {
    let alive = true;
    let objectUrl = null;
    const loadLogo = async () => {
      const logoId = formData.logo?.id || formData.logo;
      if (!logoId) { setLogoUrl(null); return; }
      const res = await axios.get(
        process.env.REACT_APP_API_HOST + `/api/v2/company/${formData.id}/logo`,
        {
          responseType: "blob",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "App-Network": localStorage.getItem("networkId"),
          },
        }
      );
      objectUrl = URL.createObjectURL(res.data);
      if (alive) setLogoUrl(objectUrl);
    };
    loadLogo().catch(() => setLogoUrl(null));
    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [formData.logo, formData.id]);

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit, submitting}) => (
      <form onSubmit={handleSubmit} className="">
        {(localStorage.getItem('roles') || '').includes(formData.id ? 'role_company_update' : 'role_company_create') &&
        <Panel headerTemplate={
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-list"}></i> {props.t('tabBasicData')}
              </h3>
            </div>
          </div>
        } className={""}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className="p-col-12 p-lg-4">
              <Field name="exchange_rate_provider" render={({input}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="exchange_rate_provider">Árfolyamforrás</label>
                  <Dropdown inputId="exchange_rate_provider" value={formData.exchange_rate_provider || 'EKB'}
                    options={[{label: 'MNB – Magyar Nemzeti Bank', value: 'MNB'}, {label: 'EKB – Európai Központi Bank', value: 'EKB'}]}
                    onChange={e => { input.onChange(e.value); setFormData({...formData, exchange_rate_provider: e.value}); }}/>
                  <small>A könyvelővel egyeztetett árfolyamforrást válaszd. A beállítás mentése nem jelent NAV-bejelentést.</small>
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-4"}>
              <Field name="vat_number" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="vat_number"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldVatNumber')}</label>
                  <span className="p-d-block">
                      <InputText id="vat_number" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     vat_number: e.target.value
                                   })
                                 }}
                                 value={formData.vat_number}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="community_vat_number" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="community_vat_number"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCommunityVatNumber')}</label>
                  <span className="p-d-block">
                      <InputText id="community_vat_number"
                                 {...input}
                                 value={formData.community_vat_number}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     community_vat_number: e.target.value
                                   })
                                 }}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="registration_number" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="registration_number"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldRegistrationNumber')}</label>
                  <span className="p-d-block">
                      <InputText id="registration_number"
                                 {...input}
                                 value={formData.registration_number}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     registration_number: e.target.value
                                   })
                                 }}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="email" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="email"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCentralEmail')}</label>
                  <span className="p-d-block">
                      <InputText id="email" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     email: e.target.value
                                   })
                                 }}
                                 value={formData.email}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-4">
              <label htmlFor="company-phone">{t('fieldPhone')}</label>
              <InputText id="company-phone" value={formData.phone || ''} onChange={e => setFormData({...formData, phone: e.target.value})}/>
            </div>
            <div className="p-col-12 p-lg-4">
              <label htmlFor="company-active">{t('fieldActive')}</label>
              <InputSwitch inputId="company-active" checked={formData.active !== false} onChange={e => setFormData({...formData, active: e.value})}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-map-marker"}></i> Székhely
              </h3>
            </div>
          </div>

          <div className={"p-grid"}>
            <div className={"p-col-12 p-md-3 p-lg-3"}>
              <Field name="address_country_code" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_country_code"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressCountry')}</label>
                  <span className="p-d-block">
                    <Dropdown options={window.App.sortDropdownOptions(countries, "name")}
                              optionLabel="name"
                              optionValue="code"
                              id={"address_country_code"}
                              emptyMessage={props.t('noCountryYet')}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  address_country_code: e.value
                                })
                              }}
                              value={formData.address_country_code}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-2 p-lg-2"}>
              <Field name="address_postal_code" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_postal_code"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressPostalCode')}</label>
                  <span className="p-d-block">
                      <InputText id="address_postal_code" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_postal_code: e.target.value
                                   })
                                 }}
                                 value={formData.address_postal_code}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-3 p-lg-3"}>
              <Field name="address_city" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_city"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCity')}</label>
                  <span className="p-d-block">
                      <InputText id="address_city" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_city: e.target.value
                                   })
                                 }}
                                 value={formData.address_city}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-4 p-lg-4"}>
              <Field name="address_detail" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_detail"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressDetail')}</label>
                  <span className="p-d-block">
                      <InputText id="address_detail" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_detail: e.target.value
                                   })
                                 }}
                                 value={formData.address_detail}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
              <Button type="submit" label={props.t('save')} icon="pi pi-check" loading={loading}
                      className="p-button-success"/>
            </div>
          </div>
        </Panel>
        }
        {formData.id && (localStorage.getItem('roles') || '').includes('role_company_update') && process.env.REACT_APP_COMPANY_NAV_INTERFACE === 'true' &&
        <>
          <Panel headerTemplate={
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <h3>
                  <i className={"pi pi-sync"}></i> NAV Interfész
                </h3>
              </div>
            </div>
          } className={"p-mt-3"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_user_name">{props.t('fieldNavUserName')}</label>
                  <span className={"p-d-block"}>
                    <InputText id="nav_user_name"
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   nav_user_name: e.target.value
                                 })
                               }}
                               value={formData.nav_user_name || ""}/>
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_user_pass">{props.t('fieldNavUserPass')}</label>
                  <span className={"p-d-block"}>
                    <Password inputId="nav_user_pass" toggleMask feedback={false}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   nav_user_pass: e.target.value
                                 })
                               }}
                               value={formData.nav_user_pass || ""}/>
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_x_m_l_sign_key">{props.t('fieldNavXmlSignKey')}</label>
                  <span className={"p-d-block"}>
                    <InputText id="nav_x_m_l_sign_key"
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   nav_x_m_l_sign_key: e.target.value
                                 })
                               }}
                               value={formData.nav_x_m_l_sign_key || ""}/>
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_x_m_l_exchange_key">{props.t('fieldNavXmlExchangeKey')}</label>
                  <span className={"p-d-block"}>
                    <InputText id="nav_x_m_l_exchange_key"
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   nav_x_m_l_exchange_key: e.target.value
                                 })
                               }}
                               value={formData.nav_x_m_l_exchange_key || ""}/>
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-3 p-xl-3"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_test">{props.t('fieldNavTest')}</label>
                  <span className={"p-d-block"}>
                    <InputSwitch
                      id="nav_test"
                      className={"p-mt-1"}
                      checked={!!formData.nav_test}
                      value={!!formData.nav_test}
                      onChange={e => setFormData({...formData, nav_test: e.target.value})}/>
                  </span>
                </div>
              </div>
            </div>
            <div className={"p-grid p-mt-1"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>
              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                <Button type="button" label={props.t('save')} icon="pi pi-check"
                        className={"p-button-success"}
                        onClick={() => {
                          saveNavSettings();
                        }}
                        loading={loading}/>
              </div>
            </div>
          </Panel>
        </>
        }
        {formData.id && process.env.REACT_APP_COMPANY_NAV_INTERFACE === 'true' &&
        <>
          <Panel headerTemplate={
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <h3>
                  <i className={"pi pi-sync"}></i> NAV adatszolgáltatás
                </h3>
              </div>
            </div>
          }
          className={"p-mt-3"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-12 p-xl-12"}>
                <div className="p-field p-fluid">
                  <label htmlFor="auto_import_nav_invoices">{props.t('fieldAutoImportNavInvoices')}</label>
                  <span className={"p-d-block"}>
                    <InputSwitch
                      id="auto_import_nav_invoices"
                      className={"p-mt-1"}
                      checked={!!formData.auto_import_nav_invoices}
                      value={!!formData.auto_import_nav_invoices}
                      onChange={e => setFormData({...formData, auto_import_nav_invoices: e.target.value})}/>
                  </span>
                </div>
              </div>
              {!!formData.auto_import_nav_invoices && (
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_invoice_receipt_group">{props.t('fieldNavInvoiceReceiptGroup')}</label>
                  <span className={"p-d-block"}>
                    <Dropdown
                      options={window.App.sortDropdownOptions(receiptGroups, "name")}
                      optionLabel="name"
                      optionValue="id"
                      id={"nav_invoice_receipt_group"}
                      emptyMessage={props.t('noReceiptGroupYet')}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          nav_invoice_receipt_group: e.value
                        })
                      }}
                      value={formData.nav_invoice_receipt_group}
                      placeholder={props.t('selectBlockPlaceholder')}/>
                  </span>
                </div>
              </div>
              )}

            </div>
            <div className={"p-grid p-mt-1"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>
              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                <Button type="button" label={props.t('save')} icon="pi pi-check"
                        className={"p-button-success"}
                        onClick={() => {
                        setLoading(true);
                        axios({
                          method: 'patch',
                          url: process.env.REACT_APP_API_HOST + "/api/v2/company/" + formData.id,
                          data: {
                            auto_import_nav_invoices: !!formData.auto_import_nav_invoices,
                            nav_invoice_receipt_group: formData.nav_invoice_receipt_group || null
                          },
                          headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                            'App-Network': localStorage.getItem("networkId")
                          }
                        })
                        .then(() => {
                          window.App.toastShow('success', t('toastSaveSuccess'));
                          loadAllCompanyData(formData.id);
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('toastError'), error.toString());
                        })
                          .finally(() => setLoading(false));
                        }}
                        loading={loading}/>
              </div>
            </div>
          </Panel>
        </>
        }
        {formData.id && (localStorage.getItem('roles') || '').includes('role_company_update') && process.env.REACT_APP_COMPANY_LOGO === 'true' &&
        <>
          <Panel headerTemplate={
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <h3>
                  <i className={"pi pi-image"}></i> Logó
                </h3>
              </div>
            </div>
          } className={"p-mt-3"}>
            <div className={"p-grid"}>
              <div className={"p-col"}>
                <div className="p-field p-fluid p-mb-3 p-text-left">
                  <label htmlFor="file">{props.t('fieldUploadedLogo')}</label>
                  {logoUrl ? (
                    <div className="p-mt-2">
                      <img  src={logoUrl} className={"w-75"} style={{ maxHeight: '200px', objectFit: 'contain' }} alt="Céglogó" />
                    </div>
                  ) : (
                    <p className="p-text-muted p-mt-2">Nincs feltöltött logó.</p>
                  )}
                </div>
              </div>
              <div className={"p-col"}>
                {!formData.logo &&
                <div className="p-field p-fluid">
                  <label htmlFor="file">{props.t('fieldImageUpload')}</label>
                  <span className="p-d-block">
                            <FileUpload mode="basic"
                                        name="file"
                                        id={"file"}
                                        auto={false}
                                        accept="image/png,image/jpeg,image/webp"
                                        maxFileSize={5242880}
                                        customUpload
                                        uploadHandler={imageUpload}
                                        chooseLabel={props.t('chooseFile')}
                                        uploadLabel={props.t('upload')}
                                        className={""}
                            />
                        </span>
                </div>
                }
                <div className="p-field p-mt-3">
                  <label htmlFor="file">{props.t('fieldImageDelete')}</label>
                  <span className="p-d-block">
                        <Button type="button"
                          className="p-button p-button-danger"
                          onClick={() => {
                            if (!window.confirm(t('confirmDelete'))) return;
                            setLoading(true);
                            apiCall('patch', `/api/v2/company/${formData.id}`, {
                              name: formData.name,
                              logo: null
                            })
                            .then(() => {
                              window.App.toastShow('success', t('toastDeleteSuccess'));
                              loadAllCompanyData(formData.id);
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('toastError'), error.toString());
                            })
                            .finally(() => setLoading(false));
                          }}
                          >
                            <i className={"pi pi-trash"}></i>&nbsp;{t('delete')}
                          </Button>
                        </span>
                </div>
              </div>
            </div>
          </Panel>
        </>
        }

      </form>
    )}/>
  )
}
export default withTranslation('common')(CompanyFormComponent);
